import { combineReducers } from '@reduxjs/toolkit';
import { appSlice } from './appSlice'; 
import { authSlice } from './authSlice';
import { userSlice } from './userSlice';
import { areasSlice } from './areasSlice';
import { outagesSlice } from './outagesSlice';
import { leadsSlice } from './leadsSlice';

const rootReducer = combineReducers({
  app: appSlice.reducer,
  auth: authSlice.reducer,
  user: userSlice.reducer,
  areas: areasSlice.reducer,
  outages: outagesSlice.reducer,
  leads: leadsSlice.reducer,
});

export default rootReducer;

